import React from 'react'
import {
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect } from 'react';

// Layouts
import DefaultLayout from './domains/auth/layouts/DefaultLayout';
import AuthLayout from './domains/auth/layouts/AuthLayout';

// Home & Static Pages
import Homepage from './domains/home/pages/Homepage';
import Privacy from './domains/miscellaneous/pages/Privacy';
import Terms from './domains/miscellaneous/pages/Terms';
import OurMission from './domains/home/pages/OurMissionPage';

// Seller Pages
import NewKinnSellerPage from './domains/seller/pages/NewKinnSellerPage';
import GetStarted from './domains/seller/pages/GetStarted';
import SellerDashboardPage from './domains/seller/pages/SellerDashboardPage';


// Shop Pages
import Search from './domains/shop/pages/Search';
import DetailRestaurant from './domains/shop/pages/DetailRestaurant';

// User Pages
import Profile from './domains/user/pages/ProfilePage';
import Orders from './domains/user/pages/OrdersPage';
import Favourites from './domains/user/pages/FavouritesPage';
import Settings from './domains/user/pages/SettingsPage';
import Help from './domains/user/pages/HelpPage';

// Order Pages
import Cart from './domains/order/pages/CartPage';
import Payment from './domains/order/pages/CheckoutPage';

// Auth Pages
import Login from './domains/auth/pages/Login';
import Signup from './domains/auth/pages/Signup';
import ForgotPassword from './domains/auth/pages/ForgotPassword';
import Confirm from './domains/auth/pages/Confirm';

// Admin Pages
import AdminDashboard from './domains/admin/pages/AdminDashboard';

const App = () => {
  let location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])
  return (
    <Routes>
      <Route path="" element={<DefaultLayout />}>
        <Route index element={<Homepage />} />
        <Route path="kinn-seller" element={<NewKinnSellerPage />} />
        <Route path="search" element={<Search />} />
        <Route path="detail/restaurant" element={<DetailRestaurant />} />
        <Route path="profile" element={<Profile />} />
        <Route path="orders" element={<Orders />} />
        <Route path="favourites" element={<Favourites />} />
        <Route path="settings" element={<Settings />} />
        <Route path="help" element={<Help />} />
        <Route path="cart" element={<Cart />} />
        <Route path="payment" element={<Payment />} />
        <Route path="seller/dashboard" element={<SellerDashboardPage />} />
        <Route path="seller/get-started" element={<GetStarted />} />
        <Route path="admin" element={<AdminDashboard />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="our-mission" element={<OurMission />} />
      </Route>
      <Route path="auth" element={<AuthLayout />}>
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="confirm" element={<Confirm />} />
      </Route>
    </Routes>
  )
}

export default App
